//
//
//
//
//
//


export default {
  props: {
    value: String,
    thirdValue: {
      type: String,
      default: '(optional)'
    }
  }
}
